"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@material-ui/core");

var MyCheckbox = function MyCheckbox(_ref) {
  var name = _ref.name,
      _onChange = _ref.onChange,
      checked = _ref.checked,
      id = _ref.id,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color;
  var isChecked = checked;
  return react_1.default.createElement(core_1.Checkbox, {
    color: color,
    checked: isChecked,
    id: id ? id : name.toString(),
    onChange: function onChange(v) {
      return _onChange({
        name: name.toString(),
        value: v.target.checked
      });
    }
  });
};

exports.default = MyCheckbox;